import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
import { commonStyles } from "../../assets/MUIStyles/commonStyles";
import { ReactComponent as ArrowBackIcon } from "../../assets/icons/arrow-back.svg";
import { ReactComponent as EyeSlashIcon } from "../../assets/icons/eye-slash.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/eye.svg";
import { registerNewAccountAction } from "../NewDevelopment/Actions/CommonActions";
import BaseButton from "../NewDevelopment/Common/Buttons/BaseButton";
import { LoadingSlides } from "../NewDevelopment/CommonComponents/Common";
import NewAuthLayout from "./NewAuthLayout";
import ErrorPopUp from "../NewDevelopment/CommonComponents/PopUpCards/ErrorPopUp";
import CommonPopup from "../NewDevelopment/CommonComponents/PopUpCards/CommonPopup";
import { ReactComponent as SuccessIcon } from "../../assets/Images/SuccessProjectIcon.svg";

function Register1() {
  const reducer = useSelector((reducer: any) => reducer);
  const {
    AccountReducer: { whitelabelDetails },
  } = reducer;
  const dispatch = useDispatch();
  const history = useHistory();
  const [spin, setSpin] = useState(false);
  const [msg, setMsg] = useState("");
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirmPassword: false,
  });
  const [state, setState] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    cpassword: "",
    agree: false,
  });
  const [errorObj, setErrorObj] = useState({
    show: false,
    errMsg: "",
  });
  const [successPopup, setSuccessPopup] = useState(false);

  const { email, password, cpassword, agree, firstName, lastName } = state;

  useEffect(() => {
    setTimeout(() => setMsg(""), 5000);
  }, [msg !== ""]);

  const handleRegister = async (e) => {
    setSpin(true);
    e.preventDefault();
    setMsg("");

    if (!email || !password || !cpassword || !firstName || !lastName) {
      setMsg(`Please fill all the fields`);
      setSpin(false);
      return;
    }

    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[!@#$%^&*()_+[\]{}|\\:;'"<>,.?/~`]/.test(password)
    ) {
      if (password === cpassword) {
        if (!agree) {
          setMsg(`Please accept terms and conditions.`);
          setSpin(false);

          return;
        }
        const obj = {
          firstName: firstName.trim(),
          lastName: lastName.trim(),
          email: email.trim(),
          password: password,
          confirmPassword: cpassword,
        };

        const res: any = await dispatch(registerNewAccountAction(obj));
        if (res?.status !== 200) {
          setErrorObj({
            show: true,
            errMsg: res?.errMsg,
          });
          setSpin(false);
          return;
        }
        if (res) {
          setSuccessPopup(true);
          setTimeout(() => {
            history.push("/");
          }, 3000);
        }
      } else {
        setMsg(`Password doesn't match `);
        setSpin(false);
        return;
      }
    } else {
      setMsg(
        " Password must be at least 8 characters must contain an uppercase, lowercase,numbers and special characters"
      );
    }
    setSpin(false);
  };

  const handleTogglePassword = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <NewAuthLayout>
      <Typography
        textTransform="capitalize"
        className="font-20-600-lightgrey"
        mb={2}
      >
        Sign Up to get started!
      </Typography>
      <Box
        maxHeight={"46vh"}
        sx={{ flex: 1, mb: 1, ...commonStyles.hideScroll }}
      >
        <Box className="flex-align-center" gap={1} mb={2}>
          <Box width={1 / 2}>
            <Typography className="font-14-grey mb-1">First Name</Typography>
            <TextField
              name="firstName"
              value={firstName}
              onChange={handleChange}
              required
              fullWidth
              placeholder="Enter your First Name"
              sx={commonStyles.inputField}
            />
          </Box>
          <Box width={1 / 2}>
            <Typography className="font-14-grey mb-1">Last Name</Typography>
            <TextField
              name="lastName"
              value={lastName}
              onChange={handleChange}
              required
              fullWidth
              placeholder="Enter your Last Name"
              sx={commonStyles.inputField}
            />
          </Box>
        </Box>

        <Box mb={2}>
          <Typography className="font-14-grey, mb-1">Email</Typography>
          <TextField
            type="email"
            name="email"
            value={email?.toLowerCase()}
            required={true}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter your email"
            sx={commonStyles.inputField}
          />
        </Box>

        <Box mb={2}>
          <Typography className="font-14-grey, mb-1">Password</Typography>
          <TextField
            type={showPassword.password ? "text" : "password"}
            required={true}
            name="password"
            value={password}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter your password"
            sx={commonStyles.inputField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePassword("password")}
                    edge="end"
                    sx={{ padding: "0", marginRight: 1.5 }}
                    disableRipple
                    disableFocusRipple
                    style={{ outline: "none" }}
                  >
                    {showPassword.password ? <EyeSlashIcon /> : <EyeIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box mb={2}>
          <Typography className="font-14-grey, mb-1">
            Confirm Password
          </Typography>
          <TextField
            type={showPassword.confirmPassword ? "text" : "password"}
            required={true}
            name="cpassword"
            value={cpassword}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Confirm your password"
            sx={commonStyles.inputField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleTogglePassword("confirmPassword")}
                    edge="end"
                    sx={{ padding: "0", marginRight: 1.5, outline: "none" }}
                    disableRipple
                    disableFocusRipple
                  >
                    {showPassword.confirmPassword ? (
                      <EyeSlashIcon />
                    ) : (
                      <EyeIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      {msg && (
        <Typography
          sx={{ color: "red", textAlign: "center", my: 0.5, fontSize: "13px" }}
        >
          {msg}
        </Typography>
      )}

      <Box mt={1}>
        <Box className="flex-xy-center" mb={1}>
          <Checkbox
            name="agree"
            checked={agree}
            onChange={() =>
              setState((prev) => ({
                ...prev,
                agree: !agree,
              }))
            }
            sx={{
              "& .MuiSvgIcon-root": {
                fontSize: 20,
              },
            }}
          />
          <Typography className="font-14-400-grey" textAlign="left" pr={2}>
            By continuing you agree to {whitelabelDetails?.documentTitle}{" "}
            <a target="_blank" href={whitelabelDetails?.termUrl}>
              <span style={{ color: "#4280FF" }}>Terms of Service</span> and{" "}
              <span style={{ color: "#4280FF" }}>Privacy Policy</span>
            </a>
          </Typography>
        </Box>

        <Button
          onClick={handleRegister}
          disabled={spin}
          variant="contained"
          sx={commonStyles.newAuthLoginButton}
          fullWidth
        >
          {spin ? <LoadingSlides bgColor="white" /> : "Sign Up"}
        </Button>

        <Box className="flex-row-center" mt={0.5}>
          <BaseButton
            title="Go Back to login"
            handleClick={() => history.push("/")}
            startIcon={<ArrowBackIcon />}
            styles={{ color: "#1A1D23", fontSize: 14, fontWeight: 400 }}
          />
        </Box>
        <ErrorPopUp
          show={errorObj.show}
          toggle={() =>
            setErrorObj((prev) => ({
              ...prev,
              show: false,
              errMsg: "",
            }))
          }
          heading={"Error"}
          message={errorObj?.errMsg}
          spin={spin}
        />
        <CommonPopup
          message={
            "Verification Email has been sent to your Email Id, Please verify to continue, if not received please check once on spam folder"
          }
          show={successPopup}
          toggle={() => {
            history.push("/");
            setSuccessPopup((prev) => !prev);
          }}
          Icon={SuccessIcon}
          heading="Email Sent"
        />
      </Box>
    </NewAuthLayout>
  );
}

export default Register1;
